<script setup lang="ts">
import { computed } from 'vue';
import type { PhoneNumbers } from '@/types/PhoneNumbers';

const props = defineProps<{
    phoneNumbers: PhoneNumbers
}>();

const dayPhoneNumber = computed(() => {
    if (props.phoneNumbers.day) {
        return `Day: ${props.phoneNumbers.day}`;
    }
    return '';
});

const eveningPhoneNumber = computed(() => {
    if (props.phoneNumbers.evening) {
        return `Evening: ${props.phoneNumbers.evening}`;
    }
    return '';
});
</script>

<template>
    {{ dayPhoneNumber }}<br>
    {{ eveningPhoneNumber }}
</template>
